import { UserPermissionCodes } from "@odata/CompanyPermissionEnums";
import { EntityTypeName } from "@odata/GeneratedEntityTypes";
import React, { lazy } from "react";

import {
    ROUTE_CORRECTIVE_INVOICE_ISSUED,
    ROUTE_CORRECTIVE_INVOICE_RECEIVED,
    ROUTE_INTERNAL_DOCUMENT,
    ROUTE_INVOICE_ISSUED,
    ROUTE_INVOICE_RECEIVED,
    ROUTE_OTHER_LIABILITY,
    ROUTE_OTHER_RECEIVABLE,
    ROUTE_PROFORMA_INVOICE_ISSUED,
    ROUTE_PROFORMA_INVOICE_RECEIVED,
    ROUTE_RECURRING_TASKS,
    ROUTE_RECURRING_TASKS_EXECUTIONS
} from "../routes";
import FormRoute from "../routes/FormRoute";
import PrivateRoute from "../routes/PrivateRoute";

const InvoicesReceived = lazy(() => import(/* webpackChunkName: "documents" */"../pages/documents/invoicesReceived/InvoicesReceived"));
const InvoiceIssued = lazy(() => import(/* webpackChunkName: "documents" */"../pages/documents/invoicesIssued/InvoicesIssued"));
const ProformaInvoicesReceived = lazy(() => import(/* webpackChunkName: "documents" */"../pages/documents/proformaInvoices/received/ProformaInvoicesReceived"));
const ProformaInvoicesIssued = lazy(() => import(/* webpackChunkName: "documents" */"../pages/documents/proformaInvoices/issued/ProformaInvoicesIssued"));
const OtherLiability = lazy(() => import(/* webpackChunkName: "documents" */"../pages/documents/otherLiability/OtherLiability"));
const OtherReceivable = lazy(() => import(/* webpackChunkName: "documents" */"../pages/documents/otherReceivable/OtherReceivable"));
const InternalDocument = lazy(() => import(/* webpackChunkName: "documents" */"../pages/documents/internalDocument/InternalDocument"));
const CorrectiveInvoicesReceived = lazy(() => import(/* webpackChunkName: "documents" */"../pages/documents/corrective/correctiveInvoiceReceived/CorrectiveInvoicesReceived"));
const CorrectiveInvoicesIssued = lazy(() => import(/* webpackChunkName: "documents" */"../pages/documents/corrective/correctiveInvoiceIssued/CorrectiveInvoicesIssued"));
const GeneratedDraftsView = lazy(() => import(/* webpackChunkName: "documents" */"../pages/recurringTasks/executions/Executions"));
const RecurringTasks = lazy(() => import(/* webpackChunkName: "documents" */"../pages/recurringTasks/RecurringTask"));

export default function documentsBundle(): React.ReactElement[] {
    return [
        <FormRoute
                path={ROUTE_INVOICE_RECEIVED}
                key={ROUTE_INVOICE_RECEIVED}
                CPs={UserPermissionCodes.InvoicesReceived}
                entityType={EntityTypeName.InvoiceReceived}
                page={InvoicesReceived}/>,
        <FormRoute
                path={ROUTE_INVOICE_ISSUED}
                key={ROUTE_INVOICE_ISSUED}
                CPs={UserPermissionCodes.InvoicesIssued}
                entityType={EntityTypeName.InvoiceIssued}
                page={InvoiceIssued}/>,
        <FormRoute
                path={ROUTE_PROFORMA_INVOICE_RECEIVED}
                key={ROUTE_PROFORMA_INVOICE_RECEIVED}
                CPs={UserPermissionCodes.InvoicesReceived}
                entityType={EntityTypeName.ProformaInvoiceReceived}
                page={ProformaInvoicesReceived}/>,
        <FormRoute
                path={ROUTE_PROFORMA_INVOICE_ISSUED}
                key={ROUTE_PROFORMA_INVOICE_ISSUED}
                CPs={UserPermissionCodes.InvoicesIssued}
                entityType={EntityTypeName.ProformaInvoiceIssued}
                page={ProformaInvoicesIssued}/>,
        <FormRoute
                path={ROUTE_OTHER_LIABILITY}
                key={ROUTE_OTHER_LIABILITY}
                CPs={UserPermissionCodes.InvoicesReceived}
                entityType={EntityTypeName.OtherLiability}
                page={OtherLiability}/>,
        <FormRoute
                path={ROUTE_OTHER_RECEIVABLE}
                key={ROUTE_OTHER_RECEIVABLE}
                CPs={UserPermissionCodes.InvoicesIssued}
                entityType={EntityTypeName.OtherReceivable}
                page={OtherReceivable}/>,
        <FormRoute
                path={ROUTE_INTERNAL_DOCUMENT}
                key={ROUTE_INTERNAL_DOCUMENT}
                entityType={EntityTypeName.InternalDocument}
                CPs={UserPermissionCodes.InternalDocuments}
                page={InternalDocument}/>,
        <FormRoute
                path={ROUTE_CORRECTIVE_INVOICE_RECEIVED}
                key={ROUTE_CORRECTIVE_INVOICE_RECEIVED}
                entityType={EntityTypeName.CorrectiveInvoiceReceived}
                CPs={UserPermissionCodes.InternalDocuments}
                page={CorrectiveInvoicesReceived}/>,
        <FormRoute
                path={ROUTE_CORRECTIVE_INVOICE_ISSUED}
                key={ROUTE_CORRECTIVE_INVOICE_ISSUED}
                entityType={EntityTypeName.CorrectiveInvoiceIssued}
                CPs={UserPermissionCodes.InternalDocuments}
                page={CorrectiveInvoicesIssued}/>,

        <PrivateRoute
                path={`${ROUTE_RECURRING_TASKS}/:ParentId${ROUTE_RECURRING_TASKS_EXECUTIONS}`}
                key={`${ROUTE_RECURRING_TASKS}/:ParentId${ROUTE_RECURRING_TASKS_EXECUTIONS}`}
                exact
                CPs={UserPermissionCodes.RecurringTask}
                component={GeneratedDraftsView}/>,

        <FormRoute
                path={ROUTE_RECURRING_TASKS}
                key={ROUTE_RECURRING_TASKS}
                entityType={EntityTypeName.RecurringTask}
                CPs={UserPermissionCodes.RecurringTask}
                page={RecurringTasks}/>
    ];
}